/* Learning Bugs basket drawer and cart page: delivery dates + "Pairs well with" */
(function () {
  // England & Wales bank holidays (update each year)
  var HOLIDAYS = ['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
                  '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28'];
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function key(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function isWorking(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) === -1;
  }
  function addWorking(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isWorking(d)) added++;
    }
    return d;
  }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function range(a, b) {
    if (a.getMonth() === b.getMonth()) return DAYS[a.getDay()] + ' ' + a.getDate() + ' – ' + fmt(b);
    return fmt(a) + ' – ' + fmt(b);
  }

  function fillDates(root) {
    var today = new Date();
    root.querySelectorAll('[data-lb-eta]:not([data-done])').forEach(function (el) {
      var parts = el.getAttribute('data-lb-eta').split('-');
      var lo = parseInt(parts[0], 10), hi = parseInt(parts[1], 10);
      if (!lo || !hi) return;
      var text = 'Arrives ' + range(addWorking(today, lo), addWorking(today, hi));
      var kind = el.getAttribute('data-kind');
      if (kind === 'made') text = 'Made to order · arrives ' + range(addWorking(today, lo), addWorking(today, hi));
      if (kind === 'express') text += ' · Express 1–3 days available';
      var t = el.querySelector('.lbk-item__eta-t');
      if (t) t.textContent = text;
      el.setAttribute('data-done', '');
    });
  }

  var recsCache = {};
  function loadPairs(root) {
    var box = root.querySelector('[data-lb-pairs]:not([data-done])');
    if (!box) return;
    box.setAttribute('data-done', '');
    var pid = box.getAttribute('data-lb-pairs');
    var inCart = box.getAttribute('data-in-cart') || '';
    var grid = box.querySelector('[data-lb-pairs-grid]');
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = base + 'recommendations/products?section_id=lb-cart-recs&limit=6&intent=complementary&product_id=' + pid;
    var p = recsCache[pid] || (recsCache[pid] = fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }));
    p.then(function (html) {
      if (!html || !grid) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var shown = 0;
      doc.querySelectorAll('.lbk-mini').forEach(function (card) {
        if (shown >= 3) return;
        if (inCart.indexOf(',' + card.getAttribute('data-pid') + ',') !== -1) return;
        grid.appendChild(card);
        shown++;
      });
      if (shown > 0) box.hidden = false;
    });
  }

  // the drawer, or the cart page (sections/main-cart.liquid) where there is no drawer
  function root() { return document.querySelector('.js-cart-drawer') || document.querySelector('.lbcp'); }

  function run() {
    var d = root();
    if (!d) return;
    fillDates(d);
    loadPairs(d);
  }

  function watch() {
    var d = root();
    if (!d) return;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 40); })
      .observe(d, { childList: true, subtree: true });
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* Cart page sticky Checkout bar (29.09.26): phones and small tablets only (under 990px).
   Shows while the summary's own Checkout button (#update-cart) is off screen, hides when it is on screen
   or the cart is empty. Adds body.lbcp-has-bar so the page gets bottom padding and nothing sits under the bar. */
(function () {
  function init() {
    var bar = document.querySelector('[data-lbcp-bar]');
    var real = document.getElementById('update-cart');
    if (!bar || !real || !window.matchMedia) return;
    var form = bar.closest('form');
    var mq = window.matchMedia('(max-width: 989px)');
    var realVisible = true;

    function hasItems() { return !(form && form.classList.contains('lbcp-hide')); }
    function update() {
      var active = mq.matches && hasItems();
      document.body.classList.toggle('lbcp-has-bar', active);
      bar.classList.toggle('is-on', active && !realVisible);
      /* 29.09.26: lets lb-quick-add.js lift the Redeemly Rewards launcher above the bar while it shows */
      document.body.classList.toggle('lbcp-bar-on', active && !realVisible);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        realVisible = entries[entries.length - 1].isIntersecting;
        update();
      }, { threshold: 0 }).observe(real);
    } else {
      realVisible = false;
    }
    if (mq.addEventListener) mq.addEventListener('change', update);
    else if (mq.addListener) mq.addListener(update);
    if (form && 'MutationObserver' in window) {
      new MutationObserver(update).observe(form, { attributes: true, attributeFilter: ['class'] });
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
